import App from "./App.svelte";

const app = new App({
	target: document.getElementById("app-root")
});

export default app;
